// extracted by mini-css-extract-plugin
export default {"dialogCard":"styles_dialogCard__0HD50","bodyWrapper":"styles_bodyWrapper__M3349"};